import { SetStateAction } from "react";

// Refines setStateAction type
export default function isSetStateAction<T>(
  setStateAction: SetStateAction<T>
): setStateAction is (p: T) => T {
  return typeof setStateAction === "function";
}
